import { render, staticRenderFns } from "./search-content.vue?vue&type=template&id=528e8a0b&scoped=true&"
import script from "./search-content.vue?vue&type=script&lang=js&"
export * from "./search-content.vue?vue&type=script&lang=js&"
import style0 from "./search-content.vue?vue&type=style&index=0&id=528e8a0b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "528e8a0b",
  null
  
)

export default component.exports